import React from 'react';
import { connect } from 'react-redux';
import { Typography } from '@mui/material';
import { LogsLoader, ResultsLoader } from '../loaders/analytics';
import EquipmentLoader from '../loaders/EquipmentLoader';
import Collapsible from '../util/Collapsible';
import ResultsViewer from './ResultsViewer';
import CodeViewer from './CodeViewer';

const ExecutionDetails = ({ execId, execution, schedule, logs, results }) =>
  execId ? (
    <div className="qa-details" key={execId}>
      <LogsLoader execId={execId} />
      <ResultsLoader execId={execId} />
      {execution.buildings?.map((bid) => (
        <EquipmentLoader key={bid} buildingId={bid} />
      ))}

      <Typography variant="h5">
        Execution #{execId} - {schedule?.name || 'ad-hoc'}
      </Typography>

      <div>
        <span>
          Analytic fetched {results?.OUT?.keys.timeseries} rows for each of{' '}
          {results?.OUT?.keys.points} points
        </span>
      </div>

      <Collapsible headerContent="Results">
        {/* assume that integer keys are point ids - this is true for CO2/air temp r^2 but may change later */}
        <ResultsViewer pointIdKeys results={results} />
      </Collapsible>

      <Collapsible headerContent={`Logs (${logs?.timestamp})`} defaultOpen={!!logs?.logs}>
        <CodeViewer code={logs?.logs} />
      </Collapsible>

      <Collapsible defaultOpen={false} headerContent="Code">
        <CodeViewer code={execution?.code} />
      </Collapsible>
    </div>
  ) : (
    <div className="qa-details">Select an execution</div>
  );

export default connect(
  (
    {
      analytics: {
        executions: { byId },
        schedules: { byId: schedulesById },
        logs,
        results,
      },
    },
    { execId }
  ) => ({
    execution: byId[execId],
    logs: logs[execId],
    results: results[execId],
    // eslint-disable-next-line camelcase
    schedule: schedulesById[byId[execId]?.schedule_id],
  })
)(ExecutionDetails);
